import { BaseModel } from '@Core';

export enum NASMountType {
    NFS,
    SMBCIFS,
}

export enum NASStatus {
    Unformatted,
    Normal,
    Offline,
    Formatting,
}

export enum EnableStatus {
    Disable,
    Enable,
}

export interface PMC8266NASConfig {
    NasIndex: number;
    NasAddress: string;
    NasFilePath: string;
    NasRecycle: EnableStatus;
    NasMountType: NASMountType;
    NasTotalSize: string;
    NasFreeSize: string;
    NasUserName: string;
    NasPassword: string;
    NasStatus: NASStatus;
}

export interface PMC8266StorageSetting extends BaseModel {
    SdcardTotalSize: string;
    SdcardFreeSize: string;
    SdcardUseSize: string;
    NasList: PMC8266NASConfig[];
}
